module.exports = __webpack_public_path__ + "img/tjmidden.07f8ffd2.jpeg";